// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","headerTitle":"Header_headerTitle__3Y2pE","headerAuthentication":"Header_headerAuthentication__2V4vT","headerOptions":"Header_headerOptions__3MnI0"};